// 9fbef606107a605d69c0edbcd8029e5d
import { OUTFIT_DETAILS_PATTERN } from '../../../../../constants/reducer.constants';

const SET_OUTFIT_PRODUCTS = `${OUTFIT_DETAILS_PATTERN}SET_OUTFIT_PRODUCTS`;
const FETCH_OUTFIT_PRODUCTS = `${OUTFIT_DETAILS_PATTERN}FETCH_OUTFIT_PRODUCTS`;
const SET_ADD_TO_FAVORITE = `${OUTFIT_DETAILS_PATTERN}SET_ADD_TO_FAVORITE`;
const SET_LOADING_STATE = `${OUTFIT_DETAILS_PATTERN}SET_LOADING_STATE`;
const RESET_OUTFIT_PRODUCTS = `${OUTFIT_DETAILS_PATTERN}RESET_OUTFIT_PRODUCTS`;
const CLEAR_OUTFIT_PRODUCTS = `${OUTFIT_DETAILS_PATTERN}CLEAR_OUTFIT_PRODUCTS`;
const SET_OUTFIT_CAROUSEL_STATE = `${OUTFIT_DETAILS_PATTERN}SET_OUTFIT_CAROUSEL_STATE`;
const SET_SELECTED_OUTFIT_PRODUCT_LIST = `${OUTFIT_DETAILS_PATTERN}SET_SELECTED_OUTFIT_PRODUCT_LIST`;
const SET_OUTFIT_CACHE = `${OUTFIT_DETAILS_PATTERN}SET_OUTFIT_CACHE`;
const RESET_OUTFIT_CACHE = `${OUTFIT_DETAILS_PATTERN}RESET_OUTFIT_CACHE`;
const REMOVE_OUTFIT_ITEM_FROM_FAVORITE = `${OUTFIT_DETAILS_PATTERN}REMOVE_OUTFIT_ITEM_FROM_FAVORITE`;
const SET_OUTFIT_PAGE = `${OUTFIT_DETAILS_PATTERN}SET_OUTFIT_PAGE`;
const SET_SELECTED_PRODUCT_ID = `${OUTFIT_DETAILS_PATTERN}SET_SELECTED_PRODUCT_ID`;
const FETCH_SELECTED_OUTFIT_FIT_PRODUCT = `${OUTFIT_DETAILS_PATTERN}FETCH_SELECTED_OUTFIT_FIT_PRODUCT`;
const UPDATE_SELECTED_OUTFIT_PRODUCT = `${OUTFIT_DETAILS_PATTERN}UPDATE_SELECTED_OUTFIT_PRODUCT`;

const OUTFIT_DETAILS_CONSTANTS = {
  SET_OUTFIT_PRODUCTS,
  FETCH_OUTFIT_PRODUCTS,
  SET_ADD_TO_FAVORITE,
  SET_LOADING_STATE,
  RESET_OUTFIT_PRODUCTS,
  CLEAR_OUTFIT_PRODUCTS,
  SET_OUTFIT_CAROUSEL_STATE,
  SET_SELECTED_OUTFIT_PRODUCT_LIST,
  SET_OUTFIT_CACHE,
  RESET_OUTFIT_CACHE,
  REMOVE_OUTFIT_ITEM_FROM_FAVORITE,
  SET_OUTFIT_PAGE,
  SET_SELECTED_PRODUCT_ID,
  FETCH_SELECTED_OUTFIT_FIT_PRODUCT,
  UPDATE_SELECTED_OUTFIT_PRODUCT,
};

export default OUTFIT_DETAILS_CONSTANTS;
